<template>
<div class="house-review-container">
  <div v-if="loadingReview" class="review-state-msg">{{ $t('pages.showReview.loading_review_a539d74') }}</div>
  <div v-else-if="!review.id" class="review-state-msg">{{ $t('pages.showReview.review_not_found_49fa790') }}</div>
  <div v-else class="reviews-section">
    
    <div class="reviews-list">
      <div  class="review-card">
        <div class="review-header">
          <div class="review-rating-large">
            <span class="rating-number">{{ formatSafety(review.average) }}</span>
          </div>
          <div class="reviewer-info">
            <div class="reviewer-avatar">
              <img :src="dreview.avatar || '/avatar/1.png'" alt="Reviewer" />
            </div>
            <div class="reviewer-details">
              <div class="reviewer-name">{{ dreview.name || 'Anonymous' }}</div>
              <div class="review-date">{{ formatDate(review.dateTime) }}</div>
            </div>
            <div class="yourself-info">
                <!--  -->
                <div class="yourself-txt" v-if="dreview.ifSelf==1"> <span class="tag1">{{ $t('pages.showReview.yourself_803037d') }}</span> </div>
            </div>

             <div class="edit-info">
                <!-- v-if="review.ifSelf==1" -->
                <button class="action-btn like-btn" @click="editDetails(review.id)" v-if="dreview.ifSelf==1"> {{ $t('pages.showReview.edit_9ead47a') }} </button>
              </div>

            <div>
              <button class="action-btn like-btn" @click="confirmDelete(review.id)" v-if="dreview.ifSelf==1"> {{ $t('pages.showReview.delete_9485989') }} </button>
            </div>

          </div>
        </div>


                <div class="review-content">
          <p class="review-text"> Review Content : {{ review.content || 'No review content provided.' }}</p>
        </div>



        <div class="pro">

            <!-- Room & Stay Info -->
            <div class="property-attributes">
              <div class="attribute-item" v-if="review.universityAbbr">
                <span class="attribute-label">{{ $t('pages.showReview.room_type_763a5f9') }}</span>
                <span class="attribute-value">{{ review.universityAbbr }}</span>
              </div>
              <div class="attribute-item" v-if="review.years">
                <span class="attribute-label">{{ $t('pages.showReview.stay_duration_6919b3d') }}</span>
                <span class="attribute-value">{{ {1:'< 3 months', 2:'3–6 months', 3:'6–12 months', 4:'1+ year'}[review.years] || 'N/A' }}</span>
              </div>
              <div class="attribute-item" v-if="review.roommatesNum != null">
                <span class="attribute-label">{{ $t('pages.showReview.roommates_be61f72') }}</span>
                <span class="attribute-value">{{ review.roommatesNum }}</span>
              </div>
            </div>

            <!-- Pricing Info -->
            <div class="property-attributes">
              <div class="attribute-item" v-if="review.sharedBathroom">
                <span class="attribute-label">{{ $t('pages.showReview.monthly_rent_4a0531d') }}</span>
                <span class="attribute-value">HKD {{ Number(review.sharedBathroom).toLocaleString() }}</span>
              </div>
              <div class="attribute-item" v-if="review.beds">
                <span class="attribute-label">{{ $t('pages.showReview.deposit_82da2bf') }}</span>
                <span class="attribute-value">HKD {{ Number(review.beds).toLocaleString() }}</span>
              </div>
              <div class="attribute-item">
                <span class="attribute-label">{{ $t('pages.showReview.bills_included_e196739') }}</span>
                <span class="attribute-value">{{ review.isDormitory ? 'Yes' : 'No' }}</span>
              </div>
            </div>

            <!-- Room Setup -->
            <div class="property-attributes">
              <div class="attribute-item" v-if="review.bedType || review.bedtype">
                <span class="attribute-label">{{ $t('pages.showReview.bed_type_f5d7e43') }}</span>
                <span class="attribute-value">{{ review.bedType || review.bedtype }}</span>
              </div>
              <div class="attribute-item">
                <span class="attribute-label">{{ $t('pages.showReview.shared_bathroom_4d9173c') }}</span>
                <span class="attribute-value">{{ review.isShared ? 'Yes' : 'No' }}</span>
              </div>
            </div>

        <!-- Insight Fields -->
        <div class="property-attributes" v-if="review.subname || review.isRealEstate !== undefined">
          <div class="attribute-item" style="flex: 1 1 100%;" v-if="review.subname">
            <span class="attribute-label">{{ $t('pages.showReview.biggest_problem_46e04d0') }}</span>
            <span class="attribute-value">{{ review.subname }}</span>
          </div>
          <div class="attribute-item" v-if="review.isRealEstate !== undefined">
            <span class="attribute-label">{{ $t('pages.showReview.recommended_7a9fe3e') }}</span>
            <span class="attribute-value" :style="{ color: review.isRealEstate === 1 ? '#22c55e' : '#ef4444' }">{{ review.isRealEstate === 1 ? 'Yes' : 'No' }}</span>
          </div>
        </div>

        <!-- Tags -->
        <div class="review-tags" v-if="review.email && review.email.length > 0">
          <span class="tag-chip" v-for="tag in review.email.split(',')" :key="tag">{{ tag.trim() }}</span>
        </div>
        </div>


  <div class="rating-breakdown-card">
    <div class="rating-grid">
      <!-- Safety -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248366345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2664" width="200" height="50">
            <path d="M945.152 174.592c0-19.456-15.872-35.328-35.328-35.84L870.4 138.24c-2.56 0-83.968-2.56-166.912-36.352-87.552-35.84-144.384-76.288-146.432-77.312l-23.552-17.408c-12.8-9.216-29.696-9.216-41.984 0l-23.552 16.896c-0.512 0.512-58.368 41.984-146.432 77.824C238.592 135.68 156.672 138.24 154.624 138.24h-40.448c-19.456 0.512-35.328 16.384-35.328 35.84v400.384c0 100.352 57.344 212.48 157.696 308.224C327.68 969.728 433.152 1024 512 1024c78.848 0 184.32-54.272 275.456-141.312 100.352-95.744 157.696-207.872 157.696-308.224V174.592z m-207.36 656.384C662.016 903.168 570.88 952.32 512 952.32s-150.016-48.64-225.792-121.344c-86.016-81.92-135.168-175.616-135.168-256V209.92h4.096c8.192 0 99.328-3.584 193.024-41.472C443.904 129.024 506.88 83.968 509.44 81.92l2.56-2.048 2.56 2.048c7.68 5.632 68.608 48.128 161.792 86.016 93.696 37.888 184.832 41.472 193.024 41.472h4.096v365.056c0 80.896-49.664 174.08-135.68 256.512z" fill="#2c2c2c" p-id="2665"></path>
      <path d="M669.184 352.256l-204.8 204.8L377.856 471.04c-17.92-17.92-46.592-17.92-64.512 0s-17.92 46.592 0 64.512l118.272 118.272c8.704 8.704 19.968 13.312 32.256 13.312s23.552-4.608 32.256-13.312l237.056-237.056c17.92-17.92 17.92-46.592 0-64.512-17.408-17.92-46.08-17.92-64 0z" fill="#2c2c2c" p-id="2666"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.safety_db6e7e4') }}</span>
          <span class="rating-score" :class="getScoreClass(review.safety)">{{ formatSafety(review.safety) }}</span>
        </div>
      </div>
      <!-- Cost Transparency -->
      <div class="rating-item">
        <div class="rating-icon">
         <svg t="1741248620729" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5013" width="48" height="48">
            <path d="M468.48 970.24l7.68 7.68 2.56 2.56c7.68 2.56 12.8 5.12 20.48 5.12 5.12 0 10.24-2.56 15.36-5.12v-2.56l10.24-5.12c2.56 0 5.12-5.12 7.68-7.68L972.8 409.6c15.36-20.48 17.92-53.76 5.12-74.24L842.24 94.72c-12.8-23.04-38.4-38.4-64-38.4H217.6c-25.6 0-51.2 15.36-61.44 35.84L20.48 327.68C7.68 350.72 10.24 384 25.6 401.92L460.8 960c5.12 7.68 7.68 7.68 7.68 10.24z m33.28-46.08L322.56 358.4h348.16L501.76 924.16z m453.12-537.6L540.16 906.24 704 363.52h250.88v23.04z m-15.36-58.88h-217.6l94.72-217.6 122.88 217.6zM788.48 92.16l-92.16 204.8L550.4 92.16h238.08z m-276.48 0l168.96 235.52H325.12L494.08 92.16H512z m-61.44 0l-145.92 204.8-92.16-204.8h238.08z m-263.68 20.48l94.72 215.04H64l122.88-215.04zM35.84 358.4h253.44L460.8 898.56 35.84 358.4z" p-id="5014"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.cost_transparency_07c6382') }}</span>
          <span class="rating-score" :class="getScoreClass(review.rentValue)">{{ formatSafety(review.rentValue) }}</span>
        </div>
      </div>
      <!-- Location Convenience -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248572206" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3867" width="48" height="48">
            <path d="M854.6 289.1c-18.8-43.4-45.7-82.3-79.9-115.7-34.2-33.4-73.9-59.5-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8-34.2 33.4-61.1 72.4-79.9 115.7-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153 6.9 4.1 14.7 6.1 22.4 6.1 7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z" p-id="3868" fill="#2c2c2c"></path>
            <path d="M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176z m79.2 255.2C570 539.3 541.9 551 512 551c-29.9 0-58-11.7-79.2-32.8C411.7 497 400 468.9 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z" p-id="3869" fill="#2c2c2c"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.location_convenience_b5ea55e') }}</span>
          <span class="rating-score" :class="getScoreClass(review.location)">{{ formatSafety(review.location) }}</span>
        </div>
      </div>
      <!-- Listing Accuracy -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248656029" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6856" width="48" height="48">
            <path d="M567.424 56a32 32 0 0 1 18.944 33.28l-38.144 305.408H896a32 32 0 0 1 24.576 52.48l-426.688 512a32 32 0 0 1-56.32-24.448l38.144-305.344H128a32 32 0 0 1-24.576-52.48l426.624-512a32 32 0 0 1 37.376-8.96z m-371.2 509.376H512a32 32 0 0 1 31.744 35.968l-29.12 232.96 313.024-375.68H512a32 32 0 0 1-31.744-35.904l29.056-233.024-313.088 375.68z" p-id="6857"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.listing_accuracy_a4530e1') }}</span>
          <span class="rating-score" :class="getScoreClass(review.utilities)">{{ formatSafety(review.utilities) }}</span>
        </div>
      </div>
      <!-- Cleanliness & Condition -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248732697" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13377" width="48" height="48">
            <path d="M580 888h296a20 20 0 0 1 20 20 20 20 0 0 1-20 20h-296a20 20 0 0 1-20-20 20 20 0 0 1 20-20zM493.2 877.28l15.52-58a20 20 0 0 1 24.48-14.08 20 20 0 0 1 14.16 24.48L531.84 888a20 20 0 0 1-24.56 14.16 20 20 0 0 1-14.08-24.88zM341.2 877.28l15.52-58a20 20 0 0 1 24.48-14.08 20 20 0 0 1 14.16 24.48L379.84 888a20 20 0 0 1-24.56 14.16 20 20 0 0 1-14.08-24.88zM417.2 877.28l15.52-58a20 20 0 0 1 24.48-14.08 20 20 0 0 1 14.16 24.48L456 888a20 20 0 0 1-24.56 14.16 20 20 0 0 1-14.24-24.88z" fill="#2c2c2c" p-id="13378"></path>
            <path d="M569.2 877.28l15.52-58a20 20 0 0 1 24.48-14.08 20 20 0 0 1 14.16 24.48L608 888a20 20 0 0 1-24.56 14.16 20 20 0 0 1-14.24-24.88z" fill="#2c2c2c" p-id="13379"></path>
            <path d="M684.32 849.52L655.36 760H324.72l-39.36 92.24a25.84 25.84 0 0 0-1.92 9.44 24 24 0 0 0 24 24h397.28a104 104 0 0 1-20.4-36.16zM298.32 720h386.08l38 117.2a64 64 0 0 0 20.88 30.32l37.12 29.68a16 16 0 0 1-10 28.48H307.44a64 64 0 0 1-64-64 63.36 63.36 0 0 1 5.2-25.12z" fill="#2c2c2c" p-id="13380"></path>
            <path d="M228 720h512a20 20 0 0 1 20 20 20 20 0 0 1-20 20h-512a20 20 0 0 1-20-20 20 20 0 0 1 20-20z" fill="#2c2c2c" p-id="13381"></path>
            <path d="M376 720h216v-16a40 40 0 0 0-40-40H416a40 40 0 0 0-40 40z m40-96h136a80 80 0 0 1 80 80v56H336v-56a80 80 0 0 1 80-80z" fill="#2c2c2c" p-id="13382"></path>
            <path d="M526.64 624l84.32-460.48a24.4 24.4 0 0 0 0-4.16A23.36 23.36 0 0 0 588 136h-9.28a40 40 0 0 0-39.36 32.8L456 624z m52.08-528h9.28a63.44 63.44 0 0 1 63.36 63.36 60 60 0 0 1-1.04 11.36L560 664H408l92-502.4a80 80 0 0 1 78.72-65.6z" fill="#2c2c2c" p-id="13383"></path>
            <path d="M250.48 397.04l8 20.56a32 32 0 0 0 17.76 17.76l20.56 8a8 8 0 0 1 4.48 10.4 8 8 0 0 1-4.48 4.48l-20.56 8a32 32 0 0 0-17.76 17.76l-8 20.56a8 8 0 0 1-14.88 0l-8-20.56a32 32 0 0 0-17.76-17.76l-20.56-8a8 8 0 0 1-4.48-10.4 8 8 0 0 1 4.48-4.48l20.56-8a32 32 0 0 0 17.76-17.76l8-20.56a8 8 0 0 1 10.4-4.48 8 8 0 0 1 4.48 4.48zM837.6 597.04l9.12 22.8a32 32 0 0 0 17.84 17.76l22.8 9.12a8 8 0 0 1 4.4 10.4 8 8 0 0 1-4.4 4.48l-22.8 9.12a32 32 0 0 0-17.84 17.84l-9.12 22.8a8 8 0 0 1-10.4 4.4 8 8 0 0 1-4.48-4.4l-9.12-22.8a32 32 0 0 0-17.76-17.84l-22.8-9.12a8 8 0 0 1-4.48-10.4 8 8 0 0 1 4.48-4.48l22.8-9.12a32 32 0 0 0 17.76-17.76l9.12-22.8a8 8 0 0 1 10.4-4.48 8 8 0 0 1 4.48 4.48z" fill="#2c2c2c" p-id="13384"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.cleanliness_condition_c3040e5') }}</span>
          <span class="rating-score" :class="getScoreClass(review.cleanliness)">{{ formatSafety(review.cleanliness) }}</span>
        </div>
      </div>
      <!-- Internet & Utilities Reliability -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248750896" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14479" width="48" height="48">
            <path d="M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6c-3.2 2.8-3.6 7.8-0.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4 0.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-0.9l36-42.9c2.8-3.3 2.4-8.3-0.9-11.2zM840.4 480.4C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4c-3.4 2.8-3.8 7.9-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1.1l36-42.9c2.8-3.4 2.4-8.5-1.1-11.3z" p-id="14480"></path>
            <path d="M957.1 341.4C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4-3.5 2.8-4 7.9-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3z" p-id="14481"></path>
            <path d="M512 778m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" p-id="14482"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.internet_utilities_reliability_6886085') }}</span>
          <span class="rating-score" :class="getScoreClass(review.internet)">{{ formatSafety(review.internet) }}</span>
        </div>
      </div>
      <!-- Noise Exposure -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248869926" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="24003" width="48" height="48">
            <path d="M409.6 336.756364l4.887273 47.941818 76.8 76.567273-33.978182-329.076364a34.210909 34.210909 0 0 0-67.258182-4.654546l-46.545454 186.181819L401.221818 372.363636zM274.850909 601.134545H64a34.210909 34.210909 0 0 0 0 68.421819H302.545455a34.210909 34.210909 0 0 0 33.28-26.065455l23.272727-101.003636L302.545455 485.934545zM933.469091 560.872727A60.509091 60.509091 0 0 0 884.363636 587.403636h-162.909091l-30.254545-166.865454a34.210909 34.210909 0 0 0-65.861818-5.585455l-46.545455 134.050909 53.76 53.76 13.498182-39.098181 10.705455 63.301818 27.927272 27.927272a43.52 43.52 0 0 0 5.818182 0H884.363636a60.741818 60.741818 0 1 0 50.036364-94.952727zM518.283636 723.316364L515.723636 698.181818l-76.8-76.8L465.454545 884.363636a34.210909 34.210909 0 0 0 30.021819 30.487273h4.189091a33.978182 33.978182 0 0 0 32.116363-23.272727l45.381818-130.792727-53.76-53.76zM174.545455 202.705455a34.210909 34.210909 0 0 0-48.407273 48.407272l661.410909 661.410909a34.210909 34.210909 0 0 0 23.272727 10.007273 34.210909 34.210909 0 0 0 23.272727-58.414545z" fill="#333333" p-id="24004"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.noise_exposure_9c76355') }}</span>
          <span class="rating-score" :class="getScoreClass(review.noiseLevel)">{{ formatSafety(review.noiseLevel) }}</span>
        </div>
      </div>
      <!-- Space Adequacy -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248893878" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="25136" width="48" height="48">
            <path d="M450.512 382.624L211.888 144H288a48 48 0 1 0 0-96H96a48 48 0 0 0-48 48v192a48 48 0 1 0 96 0v-76.112l238.624 238.624 0.048-0.048c8.64 8.352 20.368 13.536 33.328 13.536a48 48 0 0 0 48-48c0-12.96-5.184-24.688-13.552-33.328l0.064-0.048zM416 560c-12.96 0-24.688 5.2-33.312 13.568l-0.048-0.064L144 812.112V736a48 48 0 1 0-96 0v192a48 48 0 0 0 48 48h192a48 48 0 1 0 0-96h-76.112l238.624-238.624-0.048-0.048c8.352-8.64 13.536-20.352 13.536-33.328a48 48 0 0 0-48-48z m512 128a48 48 0 0 0-48 48v76.112L641.376 573.488l-0.048 0.048A47.84 47.84 0 0 0 608 560a48 48 0 0 0-48 48c0 12.976 5.184 24.688 13.568 33.328l-0.064 0.048L812.112 880H736a48 48 0 1 0 0 96h192a48 48 0 0 0 48-48V736a48 48 0 0 0-48-48z m0-640H736a48 48 0 1 0 0 96h76.112L573.488 382.624l0.048 0.048A47.872 47.872 0 0 0 560 416a48 48 0 0 0 48 48c12.976 0 24.688-5.2 33.328-13.552l0.048 0.048L880 211.888V288a48 48 0 1 0 96 0V96a48 48 0 0 0-48-48z" fill="#2c2c2c" p-id="25137"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.space_adequacy_1631412') }}</span>
          <span class="rating-score" :class="getScoreClass(review.roomSize)">{{ formatSafety(review.roomSize) }}</span>
        </div>
      </div>
      <!-- Maintenance Responsiveness -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248911883" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="26234" width="48" height="48">
            <path d="M168 88l-18.016 16.992-44.992 44.992-16.992 18.016 12.992 20.992 67.008 112 8.992 16H271.04l128 127.008c-114.336 114.912-259.84 260.8-264.992 266.016-50.144 50.112-50.304 132.288 0.96 180 50.08 49.376 131.456 50.624 179.04 0l0.96-1.024L512 691.008l198.016 198.976 2.976 2.016c50.208 47.392 130.112 47.936 177.024-2.016v-0.96h0.96c49.024-50.112 49.536-131.584-0.96-179.04l-1.024-0.96-166.976-166.016c112.32-10.464 200.32-105.376 201.984-220h0.992c0.064-0.672-0.064-1.344 0-2.016V320c3.104-37.024-4.832-72.32-24-103.008L879.04 183.04l-28 28-121.024 120.992-44.992-47.008 118.016-117.984 33.984-34.016-44-17.984A224.096 224.096 0 0 0 704 96c-123.04 0-224 100.96-224 224 0 13.408 2.848 25.056 4.992 36.992-14.016 14.08-24.544 25.504-40.992 42.016L316.992 272V176.992l-16-8.992-112-67.008-20.992-12.992zM704 160c4.544 0 7.68 2.624 12 3.008l-99.008 98.976-21.984 22.016 21.984 23.008 90.016 92.992 21.984 23.008 23.008-23.008 104-104c0.672 7.36 5.824 12.736 4.992 20.992V320c0 88.16-71.84 160-160 160-11.712 0-25.984-2.816-41.984-6.016l-17.024-2.976-12 12-360.96 361.984h-1.024v1.024c-22.784 24.864-62.528 25.44-88.992-1.024v-0.992h-1.024c-24.864-22.784-25.44-62.528 1.024-88.992 12.096-12.128 247.008-249.024 361.984-364l13.024-12.992-5.024-18.016A198.08 198.08 0 0 1 544 320c0-88.16 71.84-160 160-160z m-526.016 8l75.008 46.016v32l-6.976 6.976h-32L168 178.016l10.016-10.016z m468 388.992l199.04 198.016v0.992h0.96c24.896 22.784 25.472 62.528-0.96 88.992h-1.024v1.024c-22.784 24.864-62.528 25.44-88.992-1.024l-198.016-198.976 89.024-89.024z" p-id="26235" fill="#2c2c2c"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.maintenance_responsiveness_2cf7ad6') }}</span>
          <span class="rating-score" :class="getScoreClass(review.maintenance)">{{ formatSafety(review.maintenance) }}</span>
        </div>
      </div>
      <!-- Living Comfort -->
      <div class="rating-item">
        <div class="rating-icon">
          <svg t="1741248953112" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="28144" width="48" height="48">
            <path d="M633.856 403.136A190.784 190.784 0 0 0 704 256c0-105.856-86.144-192-192-192S320 150.144 320 256c0 59.392 27.648 111.872 70.144 147.136A224.128 224.128 0 0 0 256 608v256C256 952.256 327.808 1024 416 1024h192c88.256 0 160-71.744 160-160v-256c0-91.52-55.296-170.112-134.144-204.864zM512 128c70.592 0 128 57.408 128 128s-57.408 128-128 128-128-57.408-128-128 57.408-128 128-128z m192 736c0 52.928-43.072 96-96 96h-192c-52.928 0-96-43.072-96-96v-256C320 519.808 391.808 448 480 448h64C632.256 448 704 519.808 704 608v256zM902.4 473.92c34.88-29.376 57.6-72.832 57.6-121.92C960 263.808 888.256 192 800 192a32 32 0 0 0 0 64c52.928 0 96 43.072 96 96S852.928 448 800 448a32 32 0 0 0 0 64c88.256 0 160 71.744 160 160v192c0 17.6-14.4 32-32 32h-64a32 32 0 0 0 0 64h64c52.928 0 96-43.072 96-96v-192c0-86.4-49.728-160.704-121.6-198.08zM224 448C171.072 448 128 404.928 128 352S171.072 256 224 256a32 32 0 0 0 0-64A160.192 160.192 0 0 0 64 352c0 49.088 22.72 92.544 57.664 121.92C49.728 511.296 0 585.536 0 672v192c0 52.928 43.072 96 96 96h64a32 32 0 0 0 0-64h-64a32 32 0 0 1-32-32v-192C64 583.744 135.808 512 224 512a32 32 0 0 0 0-64z" p-id="28145" fill="#2c2c2c"></path>
          </svg>
        </div>
        <div class="rating-info">
          <span class="rating-label">{{ $t('pages.showReview.living_comfort_3754e95') }}</span>
          <span class="rating-score" :class="getScoreClass(review.roomMates)">{{ formatSafety(review.roomMates) }}</span>
        </div>
      </div>
    </div>
  </div>



     <div class="middle-section">
          <!-- Discover Section with Photos -->
      <div class="discover-section" >
        <h3 class="discover-title">{{ $t('pages.showReview.images_09e871c') }}</h3>
        <div v-if="review.file && review.file.length" class="discover-photos">
        <!-- First photo with +n overlay showing total count -->
        <div class="photo-item photo-overlay">
          <img :src="getimages(review.file)[0]" alt="review photo" class="discover-photo" />
          <div class="photo-overlay-text">+{{ getimages(review.file).length }}</div>
        </div>

        <!-- 其余三张（最多 3 张） -->
        <div
          v-for="(img, idx) in getimages(review.file)"
          :key="idx"
          class="photo-item"
        >
          <img :src="img" alt="review photo" class="discover-photo" @click="openOverlay(img)"/>
          </div>
        </div>

        <!-- 没有图片时，可选提示 -->
        <div v-else class="discover-photos">
          <p style="color:#999">{{ $t('pages.showReview.no_image_33cf70a') }}</p>
        </div>
        <!-- <div class="discover-photos">
          <div class="photo-item photo-overlay">
            <img src="/school/1.png" alt="Interior room" class="discover-photo" />
            <div class="photo-overlay-text">+3</div>
          </div>
          <div class="photo-item">
            <img src="/school/2.png" alt="Hallway" class="discover-photo" />
          </div>
          <div class="photo-item">
            <img src="/school/3.png" alt="Workspace" class="discover-photo" />
          </div>
          <div class="photo-item">
            <img src="/avatar/1.png" alt="Room view" class="discover-photo" />
          </div>
        </div> -->
      </div>
   </div>




        <div class="review-actions">
          <div class="helpful-section">
            <span class="helpful-text">{{ $t('pages.showReview.helpful_02f9858') }}</span>
            <button class="action-btn like-btn" @click="prehandlelike()">
              👍 <span>{{ review.liked || 0 }}</span>
            </button>
            <button class="action-btn unlike-btn" @click="prehandleunlike()">
              👎 <span>{{ review.unliked || 0 }}</span>
            </button>
          </div>
        </div>
        
          <div class="yes_center_mid">
            <div  class="review-form_1">
                <h2 v-if="!comments || comments.length === 0">{{ $t('pages.showReview.be_the_first_to_comment_dc12124') }}</h2>
                <h2 v-else >{{ $t('pages.showReview.comment_153d7a5') }} </h2>
                <div v-for="(comment, index1) in comments" :key="index1" class="review-item">
<div style="display: flex; align-items: flex-start;">
  <!-- 左侧内容 -->
  <div style="flex: 1;">
    <p>
      <strong>{{ $t('pages.showReview.user_3123a0e') }}</strong> {{ comment.name }}
      <span class="tag1" v-if="comment.ifSelf">{{ $t('pages.showReview.yourself_803037d') }}</span>
      <strong></strong> {{ setup(comment.dateTime) }}
    </p>



    <p><strong>{{ $t('pages.showReview.content_2459603') }}</strong> {{ comment.content }}</p>
      <!-- 右侧按钮 -->
  <!-- <div style="flex-shrink: 0; margin-left: 1rem;">
    <button
      class="action-btn like-btn"
      @click="confirmDeleteComment(comment.id)"
      v-if="comment.ifSelf == 1"
    >
      {{ $t('pages.showReview.delete_9485989') }}
    </button>
  </div> -->
  </div>

  <!-- 右侧按钮 -->
  <div style="flex-shrink: 0; margin-left: 1rem;">
    <button
      class="action-btn like-btn"
      @click="confirmDeleteComment(comment.id)"
      v-if="comment.ifSelf == 1"
    >
      {{ $t('pages.showReview.delete_9485989') }}
    </button>
  </div>
</div>

                </div>
                
                <h2>{{ $t('pages.showReview.leave_a_comment_5a91cc8') }}</h2>
                <textarea v-model="newReviewContent" :placeholder="$t('pages.showReview.write_your_review_here_26c1eea')"></textarea>
                <button @click="preaddReview()" class="submit-button">{{ $t('pages.showReview.submit_review_c191880') }}</button>
                        <div class="reviews-list1">
                
              </div>
              </div>
          </div>

      </div>
    </div>
  </div>

    <!-- Image Overlay Modal -->
    <div v-if="showOverlay" class="image-overlay" @click="showOverlay = false">
      <img :src="currentImage" alt="Full size image" class="enlarged-image" />
      <button class="close-button" @click="showOverlay = false">&times;</button>
    </div>

</div>
</template>

<style scoped>
/* Main Container */
.house-review-container {
  margin-top: 48px;
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
  background: #f8fafc; /* Light background */
  min-height: 100vh;
  color: #1f2937;
}

.review-state-msg {
  padding: 80px 24px;
  text-align: center;
  color: #64748b;
  font-size: 1.05rem;
}
.star-container{
  height: 100px;
  weight:100px;
}
/* Main Content Container */
.main-content-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  padding: 2rem;
  min-height: 60vh;
  align-items: start;
}

/* Left Content Area */
.left-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 0;
}

.overall-rating-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}

.rating-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.rating-display-large {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.rating-number-large {
  font-size: 5rem;
  font-weight: 800;
  color: #000000; /* Black color */
}

.rating-max-large {
  font-size: 1.2rem;
  color: #000000; /* Black color */
  vertical-align: top;
  line-height: 0;
  position: relative;
  top: -1.5em;
}

.rating-description {
  color: #6b7280; /* Grey text */
  font-size: 1rem;
  font-weight: 500;
}

/* Verification Badge */
.verification-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  background: transparent;
  border-radius: 20px;
  border: none;
}

.verification-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.verification-text {
  font-size: 0.85rem;
  font-weight: 500;
  color: #1e40af;
  line-height: 1.2;
  text-align: left;
}

.room-selector {
  margin-bottom: 0.5rem;
}

.room-dropdown {
  width: 100%;
}

.room-dropdown :deep(.el-input__wrapper) {
  background: white;
  border: none;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.room-dropdown :deep(.el-input__inner) {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
}
.pro{
  display: flex;
}
.property-info {
  display: flex;
  margin-bottom: 2rem;
}
.icon1{
  background-color: transparent; /* 设置背景颜色为透明 */
}
.property-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
}

.property-description {
  color: #6b7280; /* Grey text */
  line-height: 1.6;
  font-size: 1rem;
}

.rate-button {
  width: 100%;
  background: #3b82f6 !important; /* Blue button */
  border: none !important;
  padding: 1rem !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  border-radius: 12px !important;
  color: white !important;
}

.rate-button:hover {
  background: #2563eb !important;
}

.company-info {
  color: #6b7280; /* Grey text */
  font-style: italic;
  font-size: 0.9rem;
  margin-top: 1rem;
  text-align: center;
  padding: 0.5rem;
}

/* Discover Section */
.discover-section {
  margin-bottom: 2rem;
}
.star-button{
  background-color: transparent;
  border: transparent;
  margin-left: 50px;
}
.discover-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
  position: relative;
}

.discover-title::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 0;
  width: 40px;
  height: 3px;
  background: #3b82f6;
  border-radius: 2px;
}

.discover-photos {
  display: flex;
  gap: 0.75rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
  margin-top: 1rem;
}

.photo-item {
  position: relative;
  flex-shrink: 0;
  width: 125px;
  height: 150px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
  background: #f3f4f6;
}

.photo-item:hover {
  transform: scale(1.05);
}

.discover-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.yes_center_mid{
  background-color: white;
  border-radius: 20px;
}
.photo-overlay {
  position: relative;
}

.photo-overlay-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
}

/* Property Info Row */
.property-info-row {
  display: flex;
  flex-direction: row !important;
  gap: 2rem;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

/* Property Attributes Section */
.property-attributes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 2rem;
  background: rgba(234, 242, 255, 1);
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  width: 50%;
  flex: 1;
  min-height: 200px;
}

.attribute-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  text-align: center;
}

.attribute-label {
  font-size: 1rem;
  color: #1e40af;
  font-weight: 600;
}

.attribute-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e40af;
  padding: 0.75rem 1.5rem;
  background: white;
  border-radius: 25px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Address Section */
.address-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem;
  background: rgba(234, 242, 255, 1);
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  width: 50%;
  flex: 1;
  min-height: 200px;
}
.map1{
  height: 270px;
  width: 270px;
}
.out-map-placeholder{
  width: 300px;
}
.address-info {
  flex: 1;
  margin-right: 1rem;
}

.address-label {
  font-size: 1rem;
  color: #1e40af;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.address-text {
  font-size: 0.9rem;
  color: #374151;
  line-height: 1.4;
}

.address-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}
.out-address-actions{
  display: flex;
  background: rgba(234, 242, 255, 1);
}
.go-now-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #3b82f6;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.go-now-btn:hover {
  background: #2563eb;
}

.go-now-btn svg {
  width: 16px;
  height: 16px;
}

.map-placeholder {
  margin-top: 13px;
  width: 274px;
  height: 274px;
  background: #f3f4f6;
  border: 2px dashed #d1d5db;
}

/* Right Content Area */
.right-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 0;
}

.rating-breakdown-card {
  background: rgba(234, 242, 255, 1);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.rating-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(5, 1fr);
  gap: 0.75rem;
  align-items: start;
}

.rating-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: transparent;
  border-radius: 8px;
  border: none;
  min-height: 60px;
}

.rating-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e40af;
  flex-shrink: 0;
}

.rating-icon.room-size {
  color: #7c3aed;
}

.rating-icon svg {
  width: 40px;
  height: 40px;
}

.rating-info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  min-width: 0;
}

.rating-label {
  font-size: 0.85rem;
  color: #6b7280;
  font-weight: 500;
  flex-shrink: 0;
}

.rating-score {
  font-size: 1rem;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  width: fit-content;
  color: #1f2937;
  min-width: 35px;
  text-align: center;
}

.score-excellent {
  background: #dcfce7;
  color: #166534;
}

.score-good {
  background: #fef3c7;
  color: #92400e;
}

.score-poor {
  background: #fee2e2;
  color: #991b1b;
}

/* Middle Section */
.middle-section {
  max-width: 1200px;
  margin: 2rem auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 0 2rem;
}

.middle-left-column {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.middle-right-column {
  display: flex;
  flex-direction: column;
}

.top-tags-card,
.rating-distribution-card,
.similar-houses-card {
  background: rgba(234, 242, 255, 1);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.top-tags-card h3,
.rating-distribution-card h3,
.similar-houses-card h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1.5rem;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag {
  background: #3b82f6; /* Blue tags */
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.tag1 {
  background: #0cb405; /* Blue tags */
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.distribution-bars {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.distribution-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.distribution-item .rating-label {
  min-width: 80px;
  font-size: 0.9rem;
  color: #6b7280; /* Grey text */
}

.bar-container {
  flex: 1;
  height: 8px;
  background: #e5e7eb; /* Light bar background */
  border-radius: 4px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  background: #3b82f6; /* Blue bar fill */
  border-radius: 4px;
  transition: width 0.3s ease;
}

.rating-count {
  min-width: 30px;
  text-align: right;
  font-size: 0.9rem;
  color: #6b7280; /* Grey text */
  font-weight: 500;
}

.similar-houses {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.similar-house {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f9fafb; /* Light background */
  border-radius: 8px;
}

.house-rating {
  background: #3b82f6; /* Blue rating */
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
}

.house-name {
  font-weight: 500;
  color: #1f2937;
}

/* Reviews Section */
.reviews-section {
  max-width: 1200px;
  margin: 3rem auto;
  padding: 0 2rem;
  background: rgba(234, 242, 255, 1);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.reviews-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 2rem;
  text-align: center;
}

.reviews-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.review-card {
  background: rgba(234, 242, 255, 1);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.review-header {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.review-rating-large {
  background: #fef3c7; /* Yellow background */
  color: #92400e;
  padding: 1rem;
  border-radius: 12px;
  min-width: 60px;
  text-align: center;
}

.rating-number {
  font-size: 1.5rem;
  font-weight: 700;
}

.reviewer-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.yourself-info{
  flex: 1;
  display: flex;
  align-items: center;
  gap: 1rem;
  
}
.reviewer-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  background: #e5e7eb;
}

.reviewer-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.reviewer-details {
  flex: 1;
}

.reviewer-name {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.25rem;
}

.review-date {
  font-size: 0.9rem;
  color: #6b7280; /* Grey text */
}

.review-content {
  margin-bottom: 1.5rem;
}

.review-text {
  color: #374151; /* Dark grey text */
  line-height: 1.6;
  margin-bottom: 1rem;
}

.review-images {
  margin-top: 1rem;
}

.image-gallery {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.review-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.review-image:hover {
  transform: scale(1.05);
}

.review-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.review-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.helpful-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.helpful-text {
  font-size: 0.9rem;
  color: #6b7280; /* Grey text */
}

.action-btn {
  background: none;
  border: 1px solid #d1d5db;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.9rem;
  color: #374151;
}

.action-btn:hover {
  background: #f9fafb;
  border-color: #3b82f6;
}

.bookmark-btn {
  background: none;
  border: 1px solid #d1d5db;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 1.2rem;
  color: #374151;
}

.bookmark-btn:hover {
  background: #f9fafb;
  border-color: #3b82f6;
}

/* Image Overlay */
.image-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
}

.close-button {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 2rem;
  color: white;
  cursor: pointer;
  background: none;
  border: none;
  font-weight: bold;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .main-content-container {
    grid-template-columns: 1fr;
  }
  
  .middle-section {
    grid-template-columns: 1fr;
  }
  
  .rating-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .rating-grid {
    grid-template-columns: 1fr;
  }
  /* Stack the 4 attribute groups instead of fighting for row width */
  .pro {
    flex-direction: column;
    gap: 1rem;
  }
  .property-attributes {
    width: 100%;
    padding: 1rem;
    gap: 0.75rem;
    grid-template-columns: 1fr 1fr;
    min-height: 0;
  }
}

@media (max-width: 480px) {
  .main-content-container,
  .middle-section,
  .reviews-section {
    padding: 0 1rem;
  }

  .property-info-row {
    flex-direction: column;
  }

  .property-attributes,
  .address-section {
    width: 100%;
  }
  .property-attributes {
    grid-template-columns: 1fr;
  }
  .attribute-value {
    padding: 0.5rem 1rem;
    font-size: 1rem;
  }
  .review-form_1 {
    padding: 16px 16px;
  }
  .review-form_1 h2 {
    font-size: 18px;
  }

  .review-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .reviewer-info {
    flex-direction: column;
    align-items: flex-start;
  }
}

.review-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 12px 0;
}
.review-tags .tag-chip {
  padding: 4px 12px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #1e40af;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid #93c5fd;
}
</style>

<style>
.review-form_1 {
  max-width: 100%;
  margin: 30px auto;
  padding: 30px 40px;
  background-color: #f5f7fa;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.review-form_1 h2 {
  font-size: 26px;
  margin-bottom: 10px;
  color: #222;
  font-weight: 600;
}

.review-form_1 textarea {
  width: 100%;
  min-height: 140px;
  padding: 18px 20px;
  border: 2px solid #a0aec0;
  border-radius: 15px;
  resize: vertical;
  font-size: 16px;
  font-family: inherit;
  transition: border-color 0.3s, box-shadow 0.3s;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.06);
  margin-bottom: 0;
}

.review-form_1 textarea:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.5);
}

.submit-button {
  align-self: center;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  font-size: 17px;
  font-weight: 600;
  padding: 12px 32px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.4);
  transition: background 0.4s ease;
}

.submit-button:hover {
  background: linear-gradient(135deg, #2563eb, #1e40af);
  box-shadow: 0 8px 18px rgba(30, 64, 175, 0.6);
}

.reviews-list1 {
  margin-top: 30px;
  text-align: center;
}

.reviews-list1 h2 {
  font-size: 24px;
  margin-bottom: 25px;
  color: #2d3748;
  font-weight: 600;
}

.review-item {
  background-color: #ffffff;
  padding: 20px 25px;
  margin-bottom: 18px;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.07);
  text-align: left;
  transition: box-shadow 0.3s ease;
}

.review-item:hover {
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
}

.review-item p {
  margin: 8px 0;
  font-size: 15.5px;
  color: #4a5568;
  line-height: 1.4;
}

.review-item strong {
  color: #1a202c;
}
</style>
<script>
import axios from "axios";
import dayjs from "dayjs";
import Swal from 'sweetalert2';
export default {
  data() {
    return {
      dreview:{},
      review: {},
      comments: [],
      houselet:{},
      houseletId:0,
      reviewId:0,
      loadingReview: false,
      newReviewContent: '', // 用户输入的新评价内容
      currentImage: '',
      showOverlay: false,
    };
  },
  mounted() {
    const reviewId = this.$route.query.id;
    this.reviewId = reviewId;
    if (reviewId) {
      this.loadReview(reviewId);
    } else {
      console.error("No reviewId found in route");
    }
  },
  methods: {
    setup(dateTimeInput) {
      // Handle array format [year, month, day, hour, minute, second] from Java API
      if (Array.isArray(dateTimeInput)) {
        const [year, month, day, hour, minute, second] = dateTimeInput;
        const date = new Date(year, month - 1, day, hour, minute, second);
        return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
      } else if (dateTimeInput) {
        // Handle ISO string format from Node proxy
        return dayjs(dateTimeInput).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "Invalid date format";
      }
    },
      preaddReview(){
    this.addReview(this);
  },
  addReview(obj) {
      if (this.newReviewContent.trim() === '') {
        alert('Review content cannot be empty!');
        return;
      }

      // 添加新评价
     axios.get('/api/house/addComment', {
            params: {
                  rateId: obj.reviewId ,
                  content: obj.newReviewContent,
            }
        })
        .then(function (response) {
console.log(response)
            Swal.fire({
              icon: 'success',
              title: 'Add Comment Successful!',
              showConfirmButton: true,
              confirmButtonColor: '#3bc2ff',
              confirmButtonText: 'OK'
            }).then(() => {
              location.reload(true);
            });

        })
        .catch(function (error) {
          console.log(error)
        });
    },
        confirmDeleteComment(commentId) {
      Swal.fire({
        title: "Are you sure?",
        text: "This will permanently delete the comment.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        confirmButtonColor: '#3bc2ff',
        cancelButtonColor: '#64748b'
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .get(`/api/review/deleteComment?commentId=${commentId}`)
            .then((res) => {
              
console.log(res)

              Swal.fire({
              icon: 'success',
              title: 'Comment deleted',
              text: 'Your comment has been removed',
              showConfirmButton: true,
              confirmButtonColor: '#3bc2ff',
              confirmButtonText: 'OK'
            }).then(() => {
              location.reload(true);
              this.$emit("reviewDeleted", commentId);
            });
              
            })
            .catch((err) => {
              console.error(err);
              Swal.fire({
                icon: "error",
                title: "Error!",
                text: "Failed to delete comment. Please try again.",
                confirmButtonColor: '#3bc2ff'
              });
            });
        }
      });},
        confirmDelete(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "This will permanently delete the review.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        confirmButtonColor: '#3bc2ff',
        cancelButtonColor: '#64748b'
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .get(`/api/review/deleteReview?reviewId=${id}`)
            .then((res) => {

console.log(res)

              Swal.fire({
              icon: 'success',
              title: 'Review deleted',
              text: 'Your review has been removed',
              showConfirmButton: true,
              confirmButtonColor: '#3bc2ff',
              confirmButtonText: 'OK'
            }).then(() => {
              location.reload(true);
            });

             
            })
            .catch((err) => {
              console.error(err);
              Swal.fire({
                icon: "error",
                title: "Error!",
                text: "Failed to delete review. Please try again.",
                confirmButtonColor: '#3bc2ff'
              });
            });
        }
      });},
        editDetails(id) {
      this.$router.push({
        path: "/editReview",
        query: { id }
      });
    },
    mapDetailedReview(r) {
      if (!r || typeof r !== 'object') return {};
      const listingAccuracy = r.listingAccuracy != null ? r.listingAccuracy : r.utilities;
      const internetReliability = r.internetReliability != null ? r.internetReliability : r.internet;
      const costTransparency = r.costTransparency != null ? r.costTransparency : r.rentValue;
      const livingComfort = r.livingComfort != null ? r.livingComfort : r.roomMates;
      return {
        ...r,
        id: r.id,
        utilities: listingAccuracy,
        internet: internetReliability,
        rentValue: costTransparency,
        roomMates: livingComfort,
        subname: r.biggestProblem,
        isRealEstate: r.recommend === true ? 1 : r.recommend === false ? 0 : undefined,
        email: r.tags,
        sharedBathroom: r.monthlyRent,
        beds: r.deposit,
        isDormitory: r.billsIncluded,
        years: r.stayDuration != null ? r.stayDuration : r.years,
        universityAbbr: r.roomType,
      };
    },
    applyReviewPayload(r) {
      this.review = this.mapDetailedReview(r);
      this.dreview = {
        name: r.name,
        avatar: r.avatar,
        ifSelf: r.ifSelf,
      };
      this.comments = Array.isArray(r.comments) ? r.comments : [];
      this.houseletId = r.houseLetId || 0;
    },
    async loadReview(reviewId) {
      this.loadingReview = true;
      try {
        let payload = null;
        let usedPublicFallback = false;

        try {
          const detailed = await axios.get('/api/review/getDetailedReview', { params: { reviewId } });
          payload = detailed.data;
        } catch (detailErr) {
          const status = detailErr?.response?.status;
          if (status && status !== 401 && status !== 403) {
            console.warn('getDetailedReview failed, trying public getReview', detailErr);
          }
          const basic = await axios.get('/api/review/getReview', { params: { reviewId } });
          payload = basic.data;
          usedPublicFallback = true;
        }

        if (!payload || payload.id == null) {
          this.review = {};
          Swal.fire({
            icon: 'error',
            title: 'Review not found',
            text: 'No review exists for that ID.',
            confirmButtonColor: '#3bc2ff',
          });
          return;
        }

        this.applyReviewPayload(payload);
        if (usedPublicFallback && !payload.name) {
          this.dreview = { name: 'Reviewer', avatar: null, ifSelf: 0 };
        }
      } catch (err) {
        console.error('Failed to fetch review:', err);
        this.review = {};
        Swal.fire({
          icon: 'error',
          title: 'Review not found',
          text: 'Could not load this review. It may have been removed.',
          confirmButtonColor: '#3bc2ff',
        });
      } finally {
        this.loadingReview = false;
      }
    },
      openOverlay(image) {
      this.currentImage = image;
      this.showOverlay = true;
    },
    fetchComments(reviewId) {
      // Comments are included in getDetailedReview; kept for callers that refresh manually.
      this.loadReview(reviewId);
    },
    getScoreClass(value) {
      const score = parseFloat(value || 0);
      if (score >= 4.0) return 'score-excellent';
      if (score >= 3.0) return 'score-good';
      return 'score-poor';
    },
        formatSafety(value) {
      return parseFloat(value || 0).toFixed(1);
    },    formatDate(dateInput) {
  if (!dateInput) return '';
  // Handle array format [year, month, day, hour, minute, second, millisecond] from Java API
  if (Array.isArray(dateInput)) {
    const [year, month, day, hour, minute, second, millisecond] = dateInput;
    return dayjs(new Date(year, month - 1, day, hour, minute, second, millisecond || 0))
      .format('MMM DD, YYYY');
  }
  // Handle ISO string format from Node proxy
  return dayjs(dateInput).format('MMM DD, YYYY');
},
forgetReview(reviewId){
  this.loadReview(reviewId);
},
     prehandlelike(){
    this.handleLike(this);
  },

  pregethouselet(){
    this.getHouseletInfo(this)
  },
     getimages(imageUrls) {
      if (!imageUrls) return [];
      // 将字符串按逗号分割为数组
      const imagesArray = imageUrls.split(',');

      // 转换为相对路径
      const relativePaths = imagesArray.map(url => {
        // 使用正则表达式提取路径部分
        const match = url.match(/http:\/\/127\.0\.0\.1:9005(\/reviewimages\/[^?]+)(\?.*)/);
        if (match) {
          // 拼接相对路径
          return match[1] + match[2];
        }
        return url; // 如果不符合格式，返回原始URL
      });

      // 输出结果
      console.log(relativePaths);
      return relativePaths;
    },
  getHouseletInfo(obj){
    const id = this.houseletId;
    if (!id) return;
    axios
      .get('/api/review/getHouselet', { params: { id } })
      .then((res) => {
        obj.houselet = res.data;
      })
      .catch((err) => {
        console.error('Failed to fetch houselet:', err);
      });
  },
  handleLike(obj) {
      const id = this.reviewId;

      console.log(id);
      axios.put(`/api/house/like/${id}`)
              .then(function (response) {
                console.log(response)
      const currentLiked = parseInt(obj.review.liked) || 0;
      if(!obj.review.ifliked || obj.review.ifliked==0){
        obj.review.ifliked=1;
        obj.review.liked=currentLiked+1;
      }else{
        obj.review.ifliked=0;
        obj.review.liked=currentLiked-1;
      }

              })
              .catch(function (error) {
                console.log(error)
              });
  },

   prehandleunlike(){
    this.handleunLike(this);
  },
  handleunLike(obj) {
      const id = this.reviewId;

      console.log(id);
      axios.put(`/api/house/unlike/${id}`)
              .then(function (response) {
                console.log(response)
      const currentUnliked = parseInt(obj.review.unliked) || 0;
      if(!obj.review.ifunliked || obj.review.ifunliked==0){
         obj.review.ifunliked=1;
         obj.review.unliked= currentUnliked+1;
      }else{
         obj.review.ifunliked=0;
         obj.review.unliked= currentUnliked-1;
      }

              })
              .catch(function (error) {
                console.log(error)
              });
  },
  }
};
</script>
